import type { Board } from "../board";
import { getMobGoldValue } from "../economy/mobGoldValues";
import { directionFromVector } from "../direction";
import { ParticleType } from "../particleType";
import type { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import { WeakMob } from "../weakMob";
import type { XY } from "../xy";
import { AmoebaCorpse } from "./amoebaCorpse";

export class Amoeba extends WeakMob {
	static key = "Amoeba";

	constructor(xy: XY) {
		super(xy);
	}

	override getBloodParticleType(): ParticleType {
		return ParticleType.BLOOD;
	}

	override getBaseGoldValue(): number {
		return getMobGoldValue(Amoeba.key);
	}

	processMobAction(_board: Board): void {
		const passable: XY[] = [];
		for (const neighbor of this.xy.getNeighbors()) {
			if (this.canMoveTo(neighbor)) {
				passable.push(neighbor);
			}
		}
		if (passable.length === 0) return;

		const target = passable[Math.floor(Math.random() * passable.length)];
		const delta = target.subtract(this.xy);
		const dir = directionFromVector(delta);
		if (dir !== null) {
			this.setLookDirection(dir);
		}
		this.moveTo(target);
	}

	createSolidifiedVariant(): PhysicalThing | null {
		return null;
	}

	generateCorpse(): PhysicalThing | null {
		return new AmoebaCorpse(this.xy);
	}

	static deserialize(data: any): Amoeba {
		const m = new Amoeba(deserializeXY(data.xy));
		m.restoreMobFields(data);
		return m;
	}
}
